import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import styles from './NotificationSkeletons.module.scss';
export function ThreeLinePreviewSkeleton(param) {
    let { ctaButtonText, ctaTestId, testId, lineCount = 3 } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.dynamicBlock,
        "data-testid": testId,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.lines,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: cn(styles.line, styles.lineMedium)
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: cn(styles.line, styles.lineLong)
                    }),
                    lineCount === 3 && /*#__PURE__*/ _jsx("div", {
                        className: cn(styles.line, styles.lineShort)
                    })
                ]
            }),
            ctaButtonText !== '' && /*#__PURE__*/ _jsx("div", {
                className: styles.ctaWrapper,
                children: /*#__PURE__*/ _jsx("span", {
                    className: styles.cta,
                    "data-testid": ctaTestId,
                    children: ctaButtonText
                })
            })
        ]
    });
}
